import { getUrlWithoutDomain } from '@/helpers/getUrlWithoutDomain';
import type { Comedian_Entry } from '@/types/custom';
import type { ComedianWithImages } from '@/types/query-types';

export const getComedianTitle = (comedian: Comedian_Entry) => {
    return comedian.title || '';
};

export const getComedianLargeImages = (comedian: Comedian_Entry) => {
    return comedian.largeImages || [];
};

export const getComedianHeaderImage = (comedian: ComedianWithImages) => {
    return comedian.landscapeHeaderImage?.[0];
};

export const getComedianAvatar = (comedian: Comedian_Entry) => {
    return comedian.avatars || [];
};

export const getComedianShortDescription = (comedian: Comedian_Entry) => {
    return comedian.artistShortDescription || '';
};

export const getComedianLongDescription = (comedian: Comedian_Entry) => {
    return comedian.artistDescriptionHtml || '';
};

export const getComedianPageLink = (comedian: Comedian_Entry) => {
    return getUrlWithoutDomain(comedian.url || '') || '';
};
